<template>
  <RfGuidesTableView />
</template>

<script setup>
import RfGuidesTableView from "@/views/RfGuides/RfGuidesTableView.vue";
</script>
